

export const dotJoin = (...strings: string[]) : string =>
{
	return (
		strings.filter(Boolean).join('.')
	)
}